document.addEventListener("DOMContentLoaded", function () {
    const failedVariants = new Set();
    let observer = null;
    let debounceTimeout = null;

    function waitForRegiosDOPP() {
        return new Promise((resolve) => {
            if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
                resolve();
            } else {
                const observer = new MutationObserver(() => {
                    if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
                        observer.disconnect();
                        resolve();
                    }
                });
                observer.observe(document, { childList: true, subtree: true });
            }
        });
    }

    function removeEmptyBadges() {
        const multiBadges = document.querySelectorAll('.product-card-badge-multi .badge');
        multiBadges.forEach(badge => {
            if (badge.innerText.trim() === '') {
                badge.style.display = 'none';
            }
        });
    }

    async function applyDiscountLogic() {
        if (document.querySelector('.template-collection')) {
            return;
        }

        removeEmptyBadges();

        const badgeElements = document.querySelectorAll('.product-card-badge-multi .badge');
        const discountPromises = [];
        const products = {};

        badgeElements.forEach((badge) => {
            const card = badge.closest('div.product-card');
            if (!card) return;

            const productId = parseInt(card.getAttribute('data-product-id'));
            const variantId = parseInt(card.getAttribute('data-variant-id'));

            if (!productId || !variantId || isNaN(productId) || isNaN(variantId)) return;

            const key = `${productId}-${variantId}`;
            if (failedVariants.has(key)) return;

            const regularPriceInCents = parseInt(card.getAttribute('data-regular-price'));
            const compareAtPriceInCents = card.getAttribute('data-compare-at-price') ? parseInt(card.getAttribute('data-compare-at-price')) : null;
            const handle = card.getAttribute('data-handle') || "";
            const vendor = card.getAttribute('data-vendor') || "";
            const url = card.getAttribute('data-url') || "";
            const quantity = card.getAttribute('data-quantity') ? parseInt(card.getAttribute('data-quantity')) : 1;
            const collectionIds = JSON.parse(card.getAttribute('data-collections')) || [];
            const tags = card.getAttribute('data-tags') ? card.getAttribute('data-tags').split(',') : [];

            const discountPromise = window.RegiosDOPP.api.v0.calculateDiscountedPrices({
                productId,
                variantId,
                regularPriceInCents,
                compareAtPriceInCents,
                handle,
                vendor,
                url,
                quantity,
                collectionIds,
                tags
            }).then(({ salePrice, regularPrice }) => {
                const discountPercentage = window.DiscountCalculator 
                    ? window.DiscountCalculator.calculateDiscount(regularPrice.amount, salePrice.amount)
                    : Math.round((regularPrice.amount - salePrice.amount) / regularPrice.amount * 100);

                if (!products[productId]) {
                    products[productId] = [];
                }

                products[productId].push({
                    discountPercentage,
                    card,
                    badge,
                    productId,
                    variantId,
                    regularPrice: regularPrice.amount / 100,
                    salePrice: salePrice.amount / 100,
                    handle,
                    vendor,
                    url
                });

                return { discountPercentage, card };
            }).catch((error) => {
                console.error('Error calculating discounted prices:', error);
                failedVariants.add(key);
                return { discountPercentage: 0, card };
            });

            discountPromises.push(discountPromise);
        });

        await Promise.all(discountPromises);

        Object.values(products).forEach((variants) => {
            const highestDiscountVariant = variants.reduce(
                (max, current) =>
                    current.discountPercentage > max.discountPercentage ? current : max,
                { discountPercentage: 0 }
            );

            variants.forEach(({ card, badge }) => {

                const nativeBadges = card.querySelectorAll('.badge.price__badge-sale:not([data-custom])');
                nativeBadges.forEach(b => b.style.display = 'none');

                const existingCustomBadge = card.querySelector('.badge.price__badge-sale[data-custom="true"]');

                if (card === highestDiscountVariant.card && highestDiscountVariant.discountPercentage > 0) {
                    if (existingCustomBadge) {
                        existingCustomBadge.innerText = `-${Math.round(highestDiscountVariant.discountPercentage)}%`;
                        existingCustomBadge.style.display = 'block';
                    } else {
                        const newBadge = document.createElement('div');
                        newBadge.classList.add('badge', 'price__badge-sale', 'color-accent-1');
                        newBadge.setAttribute('data-custom', 'true');
                        newBadge.innerText = `-${Math.round(highestDiscountVariant.discountPercentage)}%`;
                        card.appendChild(newBadge);
                    }
                } else {
                    if (existingCustomBadge) {
                        existingCustomBadge.style.display = 'none';
                    }
                    badge.style.display = 'none';
                }
            });
        });
    }

    function observeProductGridChanges() {
        if (observer) observer.disconnect();

        observer = new MutationObserver((mutations) => {
            const relevantMutations = mutations.filter(mutation => {
                const isCustomBadgeMutation = [...mutation.addedNodes, ...mutation.removedNodes].some(node => 
                    node.nodeType === Node.ELEMENT_NODE && 
                    (node.hasAttribute?.('data-custom') || 
                    node.classList?.contains('price__badge-sale'))
                );
                return !isCustomBadgeMutation;
            });
            
            if (relevantMutations.length > 0) {
                if (debounceTimeout) clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(() => {
                    applyDiscountLogic();
                }, 150);
            }
        });

        const productGrid = document.querySelector('.product-grid-container .product-grid');
        if (productGrid) {
            observer.observe(productGrid, {
                childList: true,
                subtree: true
            });
        }
    }

    const init = () => {
        applyDiscountLogic();
        observeProductGridChanges();
        if (document.querySelector('.template-product')) {
            applyDiscountOnProductPage();
        }
    };

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('ajax:complete', init);
    document.addEventListener('theme:products:updated', init);

    function applyDiscountOnProductPage() {
        const container = document.querySelector('.price__container');
        if (!container) return;

        const productId = parseInt(container.getAttribute('data-product-id'));
        const variantId = parseInt(container.getAttribute('data-variant-id'));
        const regularPriceInCents = parseInt(container.getAttribute('data-regular-price'));
        const compareAtPriceInCents = container.getAttribute('data-compare-at-price') ? parseInt(container.getAttribute('data-compare-at-price')) : null;
        const handle = container.getAttribute('data-handle') || "";
        const vendor = container.getAttribute('data-vendor') || "";
        const url = container.getAttribute('data-url') || "";
        const quantity = container.getAttribute('data-quantity') ? parseInt(container.getAttribute('data-quantity')) : 1;
        const collectionIds = container.getAttribute('data-collections') ? JSON.parse(container.getAttribute('data-collections')) : [];
        const tags = container.getAttribute('data-tags') ? container.getAttribute('data-tags').split(',') : [];

        if (!productId || !variantId || isNaN(productId) || isNaN(variantId)) return;

        const nativeBadge = container.querySelector('.badge.price__badge-sale.color-accent-1:not([data-custom])');
        const existingCustomBadge = container.querySelector('.badge.price__badge-sale[data-custom="true"]');

        window.RegiosDOPP.api.v0.calculateDiscountedPrices({
            productId,
            variantId,
            regularPriceInCents,
            compareAtPriceInCents,
            handle,
            vendor,
            url,
            quantity,
            collectionIds,
            tags
        }).then(({ salePrice, regularPrice }) => {
            const discountPercentage = window.DiscountCalculator 
                ? window.DiscountCalculator.calculateDiscount(regularPrice.amount, salePrice.amount)
                : Math.round((regularPrice.amount - salePrice.amount) / regularPrice.amount * 100);

            if (discountPercentage > 0) {
                if (nativeBadge) nativeBadge.style.display = 'none';
                
                if (existingCustomBadge) {
                    existingCustomBadge.innerText = `-${Math.round(discountPercentage)}%`;
                    existingCustomBadge.style.display = 'block';
                } else {
                    const badge = document.createElement('div');
                    badge.classList.add('badge', 'price__badge-sale', 'color-accent-1');
                    badge.setAttribute('data-custom', 'true');
                    badge.innerText = `-${Math.round(discountPercentage)}%`;
                    container.appendChild(badge);
                }
            } else {
                if (existingCustomBadge) {
                    existingCustomBadge.style.display = 'none';
                }
            }
        }).catch((error) => {
            console.error('Erreur Regios sur page produit :', error);
        });
    }

    waitForRegiosDOPP().then(init);
});